import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { getGuideBySlug } from '../data/guides';
import { guideTone } from '../data/tones';
import { IconArrowLeft } from '../components/Icons';

export default function GuideArticle() {
  const { slug } = useParams();
  const guide = getGuideBySlug(slug);

  if (!guide) return <Navigate to="/guides" replace />;

  return (
    <article className="article">
      <Link to="/guides" className="back-link"><IconArrowLeft /> All guides</Link>

      <header className="article__head">
        <span className={`tag ${guideTone(guide.category)}`}>{guide.category}</span>
        <h1 className="article__title">{guide.title}</h1>
        <p className="article__lede">{guide.summary}</p>
      </header>

      {guide.sections.map(section => (
        <section key={section.heading} className="article__section">
          <h2>{section.heading}</h2>
          {section.body.map((para, i) => <p key={i}>{para}</p>)}
        </section>
      ))}

      {guide.furtherReading && guide.furtherReading.length > 0 && (
        <aside className="article__further">
          <h2>Further reading</h2>
          <ul>
            {guide.furtherReading.map(ref => (
              <li key={ref.url}>
                <a href={ref.url} target="_blank" rel="noopener noreferrer">{ref.label}</a>
              </li>
            ))}
          </ul>
        </aside>
      )}
    </article>
  );
}
